import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { AuthenticationType } from '../../services/oidc.factory';
import { CognitoService } from '../../services/cognito.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { environment } from 'src/environments/environment';
import { OidcConnectWiseService } from 'src/app/services/oidc.service';
import * as Sentry from '@sentry/browser';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-login',
  template: `
  <form [formGroup]="loginForm" class="dashboard-tile mat-elevation-z4">
    <div class="tile-header">
      <div class="tile-header-title">
        Login
      </div>
    </div>
    <div class="tile-content">
      <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
      <div *ngIf="loginForm.errors || timeout || invalidSso || ssoLogout">
        <mat-error *ngIf="loginForm?.errors?.invalidUser">Invalid username/password</mat-error>
        <mat-error *ngIf="loginForm?.errors?.unauthorizedUser">That user account is not authorized to access the application. Please note that if you did not use ConnectWise SSO to sign up, you cannot use your SSO account to log in to Identify.</mat-error>
        <mat-error *ngIf="timeout">Your session timed out. Please log in again.</mat-error>
        <mat-error *ngIf="ssoLogout">Your session was logged out by the sso server. Please log in again.</mat-error>
        <mat-error *ngIf="invalidSso">Unable to log in with single sign-on.</mat-error>
      </div>
      <div class="formFieldList">
        <mat-form-field>
          <input matInput placeholder="Enter your email" formControlName="email" required autocomplete="email">
        </mat-form-field>
        <mat-form-field>
          <input formControlName="password" matInput placeholder="Password" type="password" required autocomplete="password">
        </mat-form-field>
      </div>
      <div *ngIf="true" style="padding-bottom: 25px;">
        <button mat-raised-button color="primary" type="submit" (click)="onLogin()">Login</button>
        <div style="text-align: center; padding: 10px 0">or</div>
        <div style="text-align: center">
        <button mat-stroked-button color="primary" type="button" (click)="onCwLogin()">
          <mat-icon color="primary" svgIcon="cw:owl" class="inherit-color"></mat-icon>
          <span>Login with ConnectWise</span>
        </button></div>
      </div>
      <div class="tile-footer centered">
        <button mat-button type="button" color="primary" (click)="onRegister()">Register</button>
        <button mat-button type="button" color="primary" (click)="onForgotPassword()">Forgot Password</button>
      </div>
    </div>
  </form>
  `,
  styleUrls: ['./auth.layout.scss']
})
export class LoginComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @Input() timeout;
  @Input() invalidSso;
  @Input() ssoLogout;

  loginForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  constructor(private _logger: LoggerService, public _themeManager: ThemeManagerService, private _cognitoService: CognitoService, private _oidcCwService: OidcConnectWiseService, private _platformApi: PlatformApiService, private _sessionService: SessionService, private _router: Router) { }

  ngOnInit() {
  }

  onRegister() {
    if (environment.trialRegistrationUrl) {
      window.open(environment.trialRegistrationUrl, '_blank');
    }
  }

  onForgotPassword() {
    this.stateChange.emit({state:'FORGOTPASSWORD'});
  }

  onLogin() {
    this.timeout = false;
    if (this.loginForm.status == 'VALID') {
      this._sessionService.logout();
      this._cognitoService.authenticate(this.loginForm.value.email, this.loginForm.value.password).then(
        success => {
          if (success == 'SUCCESS') {
            this._sessionService.setAuthenticationType(AuthenticationType.COGNITO);
            this._platformApi.getCredentials().subscribe(
              creds => {
                this._sessionService.setApiCredentials(creds);
                this.stateChange.emit({state:'LOGINSUCCESS'})
              }, err => {
                this._logger.log('Error in standard login. Could not retrieve credentials.', {error: err});
                this._sessionService.logout();
                this.loginForm.setErrors({unauthorizedUser: true});
              }
            )
          } else if (success.status == 'MFAREQUIRED' || success.status == 'SETUPTOTPMFA') {
            this.stateChange.emit({state:success.status, secretCode: success.secretCode, cognitoUser: success.cognitoUser});
          } else if (success.status == 'NEWPASSWORD') {
            this.stateChange.emit({state:'NEWPASSWORD', username: this.loginForm.value.email, existingPassword: this.loginForm.value.password});
          }
        },
        error => {
          if (error.code === 'UserNotConfirmedException') {
            this.stateChange.emit({state:'REGISTRATIONCONFIRM', username:this.loginForm.value.email});
          } else {
            this.loginForm.setErrors({invalidUser: true});
          }
        });
    }
  }

  async onCwLogin() {
    this._oidcCwService.getManager().signinRedirect();
  }
}
